<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="body Chapter exclude-auto page-open-auto" id="Chapter1">
<p id="p101">
<a id="pagebreak-rw_8">
</a></p><a id="pagebreak-rw_8">
<div class="media image float-none floatgalley-none align-center width-auto exclude-auto" id="image3">
<div class="pc" id="pc3"><img alt="" src="a020_online.jpg"/>
</div>
</div>
</a></div><a id="pagebreak-rw_8">
</a></div><a id="pagebreak-rw_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781783784370_chapter_01.vue?af2ccce2